{
  "v": "5.9.4",
  "fr": 24,
  "ip": 0,
  "op": 96,
  "w": 500,
  "h": 500,
  "nm": "Ziro-Replacement_Icon",
  "ddd": 0,
  "assets": [
    {
      "id": "comp_0",
      "nm": "Old Phone 1",
      "fr": 24,
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "Phone 2",
          "parent": 4,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [236.148, 240.449, 0], "ix": 2, "l": 2 },
            "a": { "a": 0, "k": [236.148, 240.449, 0], "ix": 1, "l": 2 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [12.855, 36.358], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 2, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 2, "ix": 5 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [236.148, 240.449], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Phone",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 240,
          "st": 0,
          "ct": 1,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "Phone Body 2",
          "parent": 4,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [248.55, 243.15, 0], "ix": 2, "l": 2 },
            "a": { "a": 0, "k": [248.55, 243.15, 0], "ix": 1, "l": 2 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.442, 0],
                        [0, -0.442],
                        [0.442, 0],
                        [0, 0.442]
                      ],
                      "o": [
                        [0.442, 0],
                        [0, 0.442],
                        [-0.442, 0],
                        [0, -0.442]
                      ],
                      "v": [
                        [-11.5, 0.55],
                        [-10.7, 1.35],
                        [-11.5, 2.15],
                        [-12.3, 1.35]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 3",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.442, 0],
                        [0, -0.442],
                        [0.442, 0],
                        [0, 0.442]
                      ],
                      "o": [
                        [0.442, 0],
                        [0, 0.442],
                        [-0.442, 0],
                        [0, -0.442]
                      ],
                      "v": [
                        [-11.5, -2.95],
                        [-10.7, -2.15],
                        [-11.5, -1.35],
                        [-12.3, -2.15]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.442, 0],
                        [0, -0.442],
                        [0.442, 0],
                        [0, 0.442]
                      ],
                      "o": [
                        [0.442, 0],
                        [0, 0.442],
                        [-0.442, 0],
                        [0, -0.442]
                      ],
                      "v": [
                        [11.6, 0.55],
                        [12.4, 1.35],
                        [11.6, 2.15],
                        [10.8, 1.35]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 5",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 3,
                  "ty": "sh",
                  "ix": 4,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.442, 0],
                        [0, -0.442],
                        [0.442, 0],
                        [0, 0.442]
                      ],
                      "o": [
                        [0.442, 0],
                        [0, 0.442],
                        [-0.442, 0],
                        [0, -0.442]
                      ],
                      "v": [
                        [11.6, -2.95],
                        [12.4, -2.15],
                        [11.6, -1.35],
                        [10.8, -2.15]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 4,
                  "ty": "sh",
                  "ix": 5,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, -0.3],
                        [0, 0],
                        [-0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [0, 0],
                        [0.3, 0]
                      ],
                      "o": [
                        [-0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [0, 0],
                        [0.3, 0],
                        [0, 0],
                        [0, -0.3],
                        [0, 0]
                      ],
                      "v": [
                        [-7.7, -3.05],
                        [-8.3, -2.45],
                        [-8.3, 2.45],
                        [-7.7, 3.05],
                        [7.7, 3.05],
                        [8.3, 2.45],
                        [8.3, -2.45],
                        [7.7, -3.05]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 5,
                  "ty": "sh",
                  "ix": 6,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [1, 0],
                        [0, 0],
                        [0, 1.1],
                        [0, 0],
                        [-1.1, 0],
                        [0, 0],
                        [0, -1.1],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-1, 0],
                        [0, 0],
                        [0, -1],
                        [0, 0],
                        [1, 0],
                        [0, 0],
                        [0, 1]
                      ],
                      "v": [
                        [7.7, 4.35],
                        [-7.7, 4.35],
                        [-9.6, 2.45],
                        [-9.6, -2.45],
                        [-7.7, -4.35],
                        [7.7, -4.35],
                        [9.6, -2.45],
                        [9.6, 2.45]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [257.75, 235.7], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Screen",
              "np": 7,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0.1, 0.2]
                          ],
                          "v": [
                            [0.99, 0.5],
                            [-1.01, 0.5],
                            [-1.51, 0],
                            [-1.01, -0.5],
                            [0.99, -0.5],
                            [1.49, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [268.71, 255.7], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0.1, 0.3]
                          ],
                          "v": [
                            [0.99, 0.5],
                            [-1.01, 0.5],
                            [-1.51, 0],
                            [-1.01, -0.5],
                            [0.99, -0.5],
                            [1.49, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [268.71, 251.8], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0, 0.3]
                          ],
                          "v": [
                            [1, 0.5],
                            [-1, 0.5],
                            [-1.5, 0],
                            [-1, -0.5],
                            [1, -0.5],
                            [1.5, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [268.7, 248], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 3",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 3,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0.1, 0.3]
                          ],
                          "v": [
                            [0.99, 0.5],
                            [-1.01, 0.5],
                            [-1.51, 0],
                            [-1.01, -0.5],
                            [0.99, -0.5],
                            [1.49, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [268.71, 244.2], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 4",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 4,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0.1, 0.2]
                          ],
                          "v": [
                            [0.99, 0.5],
                            [-1.01, 0.5],
                            [-1.51, 0],
                            [-1.01, -0.5],
                            [0.99, -0.5],
                            [1.49, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [247.81, 255.7], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 5",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 5,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0.1, 0.3]
                          ],
                          "v": [
                            [0.99, 0.5],
                            [-1.01, 0.5],
                            [-1.51, 0],
                            [-1.01, -0.5],
                            [0.99, -0.5],
                            [1.49, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [247.81, 251.8], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 6",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 6,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0, 0.3]
                          ],
                          "v": [
                            [1, 0.5],
                            [-1, 0.5],
                            [-1.5, 0],
                            [-1, -0.5],
                            [1, -0.5],
                            [1.5, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [247.8, 248], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 7",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 7,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0.1, 0.3]
                          ],
                          "v": [
                            [0.99, 0.5],
                            [-1.01, 0.5],
                            [-1.51, 0],
                            [-1.01, -0.5],
                            [0.99, -0.5],
                            [1.49, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [247.81, 244.2], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 8",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 8,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-6.05, -2.7],
                            [-2.65, -2.7],
                            [-2.65, -5.7],
                            [-6.05, -5.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 1,
                      "ty": "sh",
                      "ix": 2,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-2.35, -2.3],
                            [-6.35, -2.3],
                            [-6.35, -6],
                            [-2.35, -6]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 2",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 2,
                      "ty": "sh",
                      "ix": 3,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-1.55, -2.7],
                            [1.45, -2.7],
                            [1.45, -5.7],
                            [-1.55, -5.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 3",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 3,
                      "ty": "sh",
                      "ix": 4,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [1.85, -2.3],
                            [-1.85, -2.3],
                            [-1.85, -6],
                            [1.85, -6]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 4",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 4,
                      "ty": "sh",
                      "ix": 5,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [2.65, -2.7],
                            [6.05, -2.7],
                            [6.05, -5.7],
                            [2.65, -5.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 5",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 5,
                      "ty": "sh",
                      "ix": 6,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [6.35, -2.3],
                            [2.35, -2.3],
                            [2.35, -6],
                            [6.35, -6]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 6",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 6,
                      "ty": "sh",
                      "ix": 7,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-6.05, 1.5],
                            [-2.65, 1.5],
                            [-2.65, -1.5],
                            [-6.05, -1.5]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 7",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 7,
                      "ty": "sh",
                      "ix": 8,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-2.35, 1.8],
                            [-6.35, 1.8],
                            [-6.35, -1.9],
                            [-2.35, -1.9]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 8",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 8,
                      "ty": "sh",
                      "ix": 9,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-1.55, 1.5],
                            [1.45, 1.5],
                            [1.45, -1.5],
                            [-1.55, -1.5]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 9",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 9,
                      "ty": "sh",
                      "ix": 10,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [1.85, 1.8],
                            [-1.85, 1.8],
                            [-1.85, -1.9],
                            [1.85, -1.9]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 10",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 10,
                      "ty": "sh",
                      "ix": 11,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [2.65, 1.5],
                            [6.05, 1.5],
                            [6.05, -1.5],
                            [2.65, -1.5]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 11",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 11,
                      "ty": "sh",
                      "ix": 12,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [6.35, 1.8],
                            [2.35, 1.8],
                            [2.35, -1.9],
                            [6.35, -1.9]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 12",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 12,
                      "ty": "sh",
                      "ix": 13,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-6.05, 5.7],
                            [-2.65, 5.7],
                            [-2.65, 2.7],
                            [-6.05, 2.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 13",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 13,
                      "ty": "sh",
                      "ix": 14,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-2.35, 6],
                            [-6.35, 6],
                            [-6.35, 2.3],
                            [-2.35, 2.3]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 14",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 14,
                      "ty": "sh",
                      "ix": 15,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-1.55, 5.7],
                            [1.45, 5.7],
                            [1.45, 2.7],
                            [-1.55, 2.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 15",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 15,
                      "ty": "sh",
                      "ix": 16,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [1.85, 6],
                            [-1.85, 6],
                            [-1.85, 2.3],
                            [1.85, 2.3]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 16",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 16,
                      "ty": "sh",
                      "ix": 17,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [2.65, 5.7],
                            [6.05, 5.7],
                            [6.05, 2.7],
                            [2.65, 2.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 17",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 17,
                      "ty": "sh",
                      "ix": 18,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [6.35, 6],
                            [2.35, 6],
                            [2.35, 2.3],
                            [6.35, 2.3]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 18",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 18,
                      "ty": "sh",
                      "ix": 19,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, -0.2],
                            [0, 0],
                            [-0.2, 0],
                            [0, 0],
                            [0, 0.2],
                            [0, 0],
                            [0.2, 0],
                            [0, 0]
                          ],
                          "o": [
                            [-0.1, 0],
                            [0, 0],
                            [0, 0.1],
                            [0, 0],
                            [0.1, 0],
                            [0, 0],
                            [0, -0.1],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-6.65, -6.5],
                            [-6.95, -6.2],
                            [-6.95, 6.4],
                            [-6.65, 6.7],
                            [6.65, 6.7],
                            [6.95, 6.4],
                            [6.95, -6.3],
                            [6.65, -6.6],
                            [-6.65, -6.6]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 19",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 19,
                      "ty": "sh",
                      "ix": 20,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [0, 0],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3]
                          ],
                          "v": [
                            [6.65, 6.9],
                            [-6.65, 6.9],
                            [-7.25, 6.3],
                            [-7.25, -6.3],
                            [-6.65, -6.9],
                            [6.65, -6.9],
                            [7.25, -6.3],
                            [7.25, 6.3]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 20",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [258.35, 250.2], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 9",
                  "np": 21,
                  "cix": 2,
                  "bm": 0,
                  "ix": 9,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [2.55, 5.9],
                            [2.55, 2.6],
                            [6.25, 2.6],
                            [6.25, 5.9]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 1,
                      "ty": "sh",
                      "ix": 2,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-6.25, 2.5],
                            [-2.55, 2.5],
                            [-2.55, 5.8],
                            [-6.25, 5.8]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 2",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 2,
                      "ty": "sh",
                      "ix": 3,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-2.55, -5.8],
                            [-2.55, -2.5],
                            [-6.25, -2.5],
                            [-6.25, -5.8]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 3",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 3,
                      "ty": "sh",
                      "ix": 4,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [6.25, -2.5],
                            [2.55, -2.5],
                            [2.55, -5.8],
                            [6.25, -5.8]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 4",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 4,
                      "ty": "sh",
                      "ix": 5,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [2.55, -1.6],
                            [6.25, -1.6],
                            [6.25, 1.7],
                            [2.55, 1.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 5",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 5,
                      "ty": "sh",
                      "ix": 6,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-1.65, -2.5],
                            [-1.65, -5.8],
                            [1.65, -5.8],
                            [1.65, -2.5]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 6",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 6,
                      "ty": "sh",
                      "ix": 7,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-6.25, -1.6],
                            [-2.55, -1.6],
                            [-2.55, 1.7],
                            [-6.25, 1.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 7",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 7,
                      "ty": "sh",
                      "ix": 8,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [1.65, 2.5],
                            [1.65, 5.8],
                            [-1.65, 5.8],
                            [-1.65, 2.5]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 8",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 8,
                      "ty": "sh",
                      "ix": 9,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-1.65, 1.7],
                            [-1.65, -1.6],
                            [1.65, -1.6],
                            [1.65, 1.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 9",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 9,
                      "ty": "sh",
                      "ix": 10,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.2, 0],
                            [0, 0],
                            [0, -0.2],
                            [0, 0],
                            [-0.2, 0],
                            [0, 0],
                            [0, 0.2],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [-0.2, 0],
                            [0, 0],
                            [0, 0.2],
                            [0, 0],
                            [0.2, 0],
                            [0, 0],
                            [0, -0.2]
                          ],
                          "v": [
                            [6.65, -6.7],
                            [-6.65, -6.7],
                            [-7.05, -6.3],
                            [-7.05, 6.3],
                            [-6.65, 6.7],
                            [6.65, 6.7],
                            [7.05, 6.3],
                            [7.05, -6.3]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 10",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [258.35, 250.2], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 10",
                  "np": 11,
                  "cix": 2,
                  "bm": 0,
                  "ix": 10,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [268.21, 244.7], "ix": 2 },
                  "a": { "a": 0, "k": [268.71, 244.2], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Buttons",
              "np": 10,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [48.926, 36.963], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 3, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 2, "ix": 5 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [248.483, 245.352], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "BG",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 240,
          "st": 0,
          "ct": 1,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "Buttons 2",
          "parent": 4,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [253.542, 246.464, 0], "ix": 2, "l": 2 },
            "a": { "a": 0, "k": [25.095, 16.96, 0], "ix": 1, "l": 2 },
            "s": { "a": 0, "k": [20, 20, 100], "ix": 6, "l": 2 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": { "a": 0, "k": 0, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [25.22, 16.96], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.956, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": { "a": 0, "k": 0, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [46.709, 16.96], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "2",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": { "a": 0, "k": 0, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [67.686, 16.96], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "3",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": { "a": 0, "k": 0, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [25.22, 38.531], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.956, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "4",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": { "a": 0, "k": 0, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [46.709, 38.531], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "5",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 5,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": { "a": 0, "k": 0, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [67.686, 38.531], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "6",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 6,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": { "a": 0, "k": 0, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [25.22, 59.414], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.956, 93.085], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "7",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 7,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": { "a": 0, "k": 0, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [46.709, 59.414], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.443, 93.085], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "8",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 8,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": { "a": 0, "k": 0, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [67.686, 59.414], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.443, 93.085], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "9",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 9,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 240,
          "st": 0,
          "ct": 1,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "Phone BG 2",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [250.136, 240.391, 0], "ix": 2, "l": 2 },
            "a": { "a": 0, "k": [248.55, 243.15, 0], "ix": 1, "l": 2 },
            "s": { "a": 0, "k": [500, 500, 100], "ix": 6, "l": 2 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [18.206, 7.842], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 1.4, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [257.826, 235.593], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Rectangle 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [48.926, 36.963], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 3, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [248.483, 245.352], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "BG",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 6,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 240,
          "st": 0,
          "ct": 1,
          "bm": 0
        }
      ]
    },
    {
      "id": "comp_1",
      "nm": "New Phone",
      "fr": 24,
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "Phone",
          "parent": 4,
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11,
              "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Phone BG').transform.opacity;"
            },
            "r": {
              "a": 1,
              "k": [
                { "t": 59, "s": [0], "h": 1 },
                { "t": 61, "s": [2], "h": 1 },
                { "t": 63, "s": [-1], "h": 1 },
                { "t": 65, "s": [1], "h": 1 },
                { "t": 67, "s": [-2], "h": 1 },
                { "t": 69, "s": [1], "h": 1 },
                { "t": 71, "s": [0], "h": 1 }
              ],
              "ix": 10
            },
            "p": { "a": 0, "k": [236.148, 240.449, 0], "ix": 2, "l": 2 },
            "a": { "a": 0, "k": [236.148, 240.449, 0], "ix": 1, "l": 2 },
            "s": {
              "a": 1,
              "k": [
                { "t": 59, "s": [100, 100, 100], "h": 1 },
                { "t": 62, "s": [102, 102, 100], "h": 1 },
                { "t": 65, "s": [100, 100, 100], "h": 1 },
                { "t": 68, "s": [102, 102, 100], "h": 1 },
                { "t": 71, "s": [100, 100, 100], "h": 1 }
              ],
              "ix": 6,
              "l": 2
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [12.855, 36.358], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 2, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 2, "ix": 5 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [236.148, 240.449], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Phone",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 240,
          "st": 0,
          "ct": 1,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "Phone Body",
          "parent": 4,
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11,
              "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Phone BG').transform.opacity;"
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [248.55, 243.15, 0], "ix": 2, "l": 2 },
            "a": { "a": 0, "k": [248.55, 243.15, 0], "ix": 1, "l": 2 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.442, 0],
                        [0, -0.442],
                        [0.442, 0],
                        [0, 0.442]
                      ],
                      "o": [
                        [0.442, 0],
                        [0, 0.442],
                        [-0.442, 0],
                        [0, -0.442]
                      ],
                      "v": [
                        [-11.5, 0.55],
                        [-10.7, 1.35],
                        [-11.5, 2.15],
                        [-12.3, 1.35]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 3",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.442, 0],
                        [0, -0.442],
                        [0.442, 0],
                        [0, 0.442]
                      ],
                      "o": [
                        [0.442, 0],
                        [0, 0.442],
                        [-0.442, 0],
                        [0, -0.442]
                      ],
                      "v": [
                        [-11.5, -2.95],
                        [-10.7, -2.15],
                        [-11.5, -1.35],
                        [-12.3, -2.15]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.442, 0],
                        [0, -0.442],
                        [0.442, 0],
                        [0, 0.442]
                      ],
                      "o": [
                        [0.442, 0],
                        [0, 0.442],
                        [-0.442, 0],
                        [0, -0.442]
                      ],
                      "v": [
                        [11.6, 0.55],
                        [12.4, 1.35],
                        [11.6, 2.15],
                        [10.8, 1.35]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 5",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 3,
                  "ty": "sh",
                  "ix": 4,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-0.442, 0],
                        [0, -0.442],
                        [0.442, 0],
                        [0, 0.442]
                      ],
                      "o": [
                        [0.442, 0],
                        [0, 0.442],
                        [-0.442, 0],
                        [0, -0.442]
                      ],
                      "v": [
                        [11.6, -2.95],
                        [12.4, -2.15],
                        [11.6, -1.35],
                        [10.8, -2.15]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 4,
                  "ty": "sh",
                  "ix": 5,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, -0.3],
                        [0, 0],
                        [-0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [0, 0],
                        [0.3, 0]
                      ],
                      "o": [
                        [-0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [0, 0],
                        [0.3, 0],
                        [0, 0],
                        [0, -0.3],
                        [0, 0]
                      ],
                      "v": [
                        [-7.7, -3.05],
                        [-8.3, -2.45],
                        [-8.3, 2.45],
                        [-7.7, 3.05],
                        [7.7, 3.05],
                        [8.3, 2.45],
                        [8.3, -2.45],
                        [7.7, -3.05]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 5,
                  "ty": "sh",
                  "ix": 6,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [1, 0],
                        [0, 0],
                        [0, 1.1],
                        [0, 0],
                        [-1.1, 0],
                        [0, 0],
                        [0, -1.1],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-1, 0],
                        [0, 0],
                        [0, -1],
                        [0, 0],
                        [1, 0],
                        [0, 0],
                        [0, 1]
                      ],
                      "v": [
                        [7.7, 4.35],
                        [-7.7, 4.35],
                        [-9.6, 2.45],
                        [-9.6, -2.45],
                        [-7.7, -4.35],
                        [7.7, -4.35],
                        [9.6, -2.45],
                        [9.6, 2.45]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [257.75, 235.7], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Screen",
              "np": 7,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0.1, 0.2]
                          ],
                          "v": [
                            [0.99, 0.5],
                            [-1.01, 0.5],
                            [-1.51, 0],
                            [-1.01, -0.5],
                            [0.99, -0.5],
                            [1.49, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [268.71, 255.7], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0.1, 0.3]
                          ],
                          "v": [
                            [0.99, 0.5],
                            [-1.01, 0.5],
                            [-1.51, 0],
                            [-1.01, -0.5],
                            [0.99, -0.5],
                            [1.49, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [268.71, 251.8], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0, 0.3]
                          ],
                          "v": [
                            [1, 0.5],
                            [-1, 0.5],
                            [-1.5, 0],
                            [-1, -0.5],
                            [1, -0.5],
                            [1.5, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [268.7, 248], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 3",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 3,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0.1, 0.3]
                          ],
                          "v": [
                            [0.99, 0.5],
                            [-1.01, 0.5],
                            [-1.51, 0],
                            [-1.01, -0.5],
                            [0.99, -0.5],
                            [1.49, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [268.71, 244.2], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 4",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 4,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0.1, 0.2]
                          ],
                          "v": [
                            [0.99, 0.5],
                            [-1.01, 0.5],
                            [-1.51, 0],
                            [-1.01, -0.5],
                            [0.99, -0.5],
                            [1.49, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [247.81, 255.7], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 5",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 5,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0.1, 0.3]
                          ],
                          "v": [
                            [0.99, 0.5],
                            [-1.01, 0.5],
                            [-1.51, 0],
                            [-1.01, -0.5],
                            [0.99, -0.5],
                            [1.49, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [247.81, 251.8], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 6",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 6,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0, 0.3]
                          ],
                          "v": [
                            [1, 0.5],
                            [-1, 0.5],
                            [-1.5, 0],
                            [-1, -0.5],
                            [1, -0.5],
                            [1.5, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [247.8, 248], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 7",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 7,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0.1, 0.3]
                          ],
                          "v": [
                            [0.99, 0.5],
                            [-1.01, 0.5],
                            [-1.51, 0],
                            [-1.01, -0.5],
                            [0.99, -0.5],
                            [1.49, 0]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [247.81, 244.2], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 8",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 8,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-6.05, -2.7],
                            [-2.65, -2.7],
                            [-2.65, -5.7],
                            [-6.05, -5.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 1,
                      "ty": "sh",
                      "ix": 2,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-2.35, -2.3],
                            [-6.35, -2.3],
                            [-6.35, -6],
                            [-2.35, -6]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 2",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 2,
                      "ty": "sh",
                      "ix": 3,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-1.55, -2.7],
                            [1.45, -2.7],
                            [1.45, -5.7],
                            [-1.55, -5.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 3",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 3,
                      "ty": "sh",
                      "ix": 4,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [1.85, -2.3],
                            [-1.85, -2.3],
                            [-1.85, -6],
                            [1.85, -6]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 4",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 4,
                      "ty": "sh",
                      "ix": 5,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [2.65, -2.7],
                            [6.05, -2.7],
                            [6.05, -5.7],
                            [2.65, -5.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 5",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 5,
                      "ty": "sh",
                      "ix": 6,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [6.35, -2.3],
                            [2.35, -2.3],
                            [2.35, -6],
                            [6.35, -6]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 6",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 6,
                      "ty": "sh",
                      "ix": 7,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-6.05, 1.5],
                            [-2.65, 1.5],
                            [-2.65, -1.5],
                            [-6.05, -1.5]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 7",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 7,
                      "ty": "sh",
                      "ix": 8,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-2.35, 1.8],
                            [-6.35, 1.8],
                            [-6.35, -1.9],
                            [-2.35, -1.9]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 8",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 8,
                      "ty": "sh",
                      "ix": 9,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-1.55, 1.5],
                            [1.45, 1.5],
                            [1.45, -1.5],
                            [-1.55, -1.5]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 9",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 9,
                      "ty": "sh",
                      "ix": 10,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [1.85, 1.8],
                            [-1.85, 1.8],
                            [-1.85, -1.9],
                            [1.85, -1.9]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 10",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 10,
                      "ty": "sh",
                      "ix": 11,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [2.65, 1.5],
                            [6.05, 1.5],
                            [6.05, -1.5],
                            [2.65, -1.5]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 11",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 11,
                      "ty": "sh",
                      "ix": 12,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [6.35, 1.8],
                            [2.35, 1.8],
                            [2.35, -1.9],
                            [6.35, -1.9]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 12",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 12,
                      "ty": "sh",
                      "ix": 13,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-6.05, 5.7],
                            [-2.65, 5.7],
                            [-2.65, 2.7],
                            [-6.05, 2.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 13",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 13,
                      "ty": "sh",
                      "ix": 14,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-2.35, 6],
                            [-6.35, 6],
                            [-6.35, 2.3],
                            [-2.35, 2.3]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 14",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 14,
                      "ty": "sh",
                      "ix": 15,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-1.55, 5.7],
                            [1.45, 5.7],
                            [1.45, 2.7],
                            [-1.55, 2.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 15",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 15,
                      "ty": "sh",
                      "ix": 16,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [1.85, 6],
                            [-1.85, 6],
                            [-1.85, 2.3],
                            [1.85, 2.3]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 16",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 16,
                      "ty": "sh",
                      "ix": 17,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [2.65, 5.7],
                            [6.05, 5.7],
                            [6.05, 2.7],
                            [2.65, 2.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 17",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 17,
                      "ty": "sh",
                      "ix": 18,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [6.35, 6],
                            [2.35, 6],
                            [2.35, 2.3],
                            [6.35, 2.3]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 18",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 18,
                      "ty": "sh",
                      "ix": 19,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, -0.2],
                            [0, 0],
                            [-0.2, 0],
                            [0, 0],
                            [0, 0.2],
                            [0, 0],
                            [0.2, 0],
                            [0, 0]
                          ],
                          "o": [
                            [-0.1, 0],
                            [0, 0],
                            [0, 0.1],
                            [0, 0],
                            [0.1, 0],
                            [0, 0],
                            [0, -0.1],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-6.65, -6.5],
                            [-6.95, -6.2],
                            [-6.95, 6.4],
                            [-6.65, 6.7],
                            [6.65, 6.7],
                            [6.95, 6.4],
                            [6.95, -6.3],
                            [6.65, -6.6],
                            [-6.65, -6.6]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 19",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 19,
                      "ty": "sh",
                      "ix": 20,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3],
                            [0, 0],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [-0.3, 0],
                            [0, 0],
                            [0, -0.3],
                            [0, 0],
                            [0.3, 0],
                            [0, 0],
                            [0, 0.3]
                          ],
                          "v": [
                            [6.65, 6.9],
                            [-6.65, 6.9],
                            [-7.25, 6.3],
                            [-7.25, -6.3],
                            [-6.65, -6.9],
                            [6.65, -6.9],
                            [7.25, -6.3],
                            [7.25, 6.3]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 20",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [258.35, 250.2], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 9",
                  "np": 21,
                  "cix": 2,
                  "bm": 0,
                  "ix": 9,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [2.55, 5.9],
                            [2.55, 2.6],
                            [6.25, 2.6],
                            [6.25, 5.9]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 1,
                      "ty": "sh",
                      "ix": 2,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-6.25, 2.5],
                            [-2.55, 2.5],
                            [-2.55, 5.8],
                            [-6.25, 5.8]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 2",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 2,
                      "ty": "sh",
                      "ix": 3,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-2.55, -5.8],
                            [-2.55, -2.5],
                            [-6.25, -2.5],
                            [-6.25, -5.8]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 3",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 3,
                      "ty": "sh",
                      "ix": 4,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [6.25, -2.5],
                            [2.55, -2.5],
                            [2.55, -5.8],
                            [6.25, -5.8]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 4",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 4,
                      "ty": "sh",
                      "ix": 5,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [2.55, -1.6],
                            [6.25, -1.6],
                            [6.25, 1.7],
                            [2.55, 1.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 5",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 5,
                      "ty": "sh",
                      "ix": 6,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-1.65, -2.5],
                            [-1.65, -5.8],
                            [1.65, -5.8],
                            [1.65, -2.5]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 6",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 6,
                      "ty": "sh",
                      "ix": 7,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-6.25, -1.6],
                            [-2.55, -1.6],
                            [-2.55, 1.7],
                            [-6.25, 1.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 7",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 7,
                      "ty": "sh",
                      "ix": 8,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [1.65, 2.5],
                            [1.65, 5.8],
                            [-1.65, 5.8],
                            [-1.65, 2.5]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 8",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 8,
                      "ty": "sh",
                      "ix": 9,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-1.65, 1.7],
                            [-1.65, -1.6],
                            [1.65, -1.6],
                            [1.65, 1.7]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 9",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 9,
                      "ty": "sh",
                      "ix": 10,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.2, 0],
                            [0, 0],
                            [0, -0.2],
                            [0, 0],
                            [-0.2, 0],
                            [0, 0],
                            [0, 0.2],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [-0.2, 0],
                            [0, 0],
                            [0, 0.2],
                            [0, 0],
                            [0.2, 0],
                            [0, 0],
                            [0, -0.2]
                          ],
                          "v": [
                            [6.65, -6.7],
                            [-6.65, -6.7],
                            [-7.05, -6.3],
                            [-7.05, 6.3],
                            [-6.65, 6.7],
                            [6.65, 6.7],
                            [7.05, 6.3],
                            [7.05, -6.3]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 10",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [258.35, 250.2], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 10",
                  "np": 11,
                  "cix": 2,
                  "bm": 0,
                  "ix": 10,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [268.21, 244.7], "ix": 2 },
                  "a": { "a": 0, "k": [268.71, 244.2], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Buttons",
              "np": 10,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [48.926, 36.963], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 3, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 2, "ix": 5 },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [248.483, 245.352], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "BG",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 240,
          "st": 0,
          "ct": 1,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "Buttons",
          "parent": 4,
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11,
              "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Phone BG').transform.opacity;"
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [253.542, 246.464, 0], "ix": 2, "l": 2 },
            "a": { "a": 0, "k": [25.095, 16.96, 0], "ix": 1, "l": 2 },
            "s": { "a": 0, "k": [20, 20, 100], "ix": 6, "l": 2 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": {
                    "a": 1,
                    "k": [
                      { "t": 0, "s": [0], "h": 1 },
                      { "t": 42, "s": [100], "h": 1 },
                      { "t": 45, "s": [0], "h": 1 }
                    ],
                    "ix": 5
                  },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [25.22, 16.96], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.956, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": { "a": 0, "k": 0, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [46.709, 16.96], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "2",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": {
                    "a": 1,
                    "k": [
                      { "t": 0, "s": [0], "h": 1 },
                      { "t": 34, "s": [100], "h": 1 },
                      { "t": 37, "s": [0], "h": 1 }
                    ],
                    "ix": 5
                  },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [67.686, 16.96], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "3",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": {
                    "a": 1,
                    "k": [
                      { "t": 0, "s": [0], "h": 1 },
                      { "t": 50, "s": [100], "h": 1 },
                      { "t": 53, "s": [0], "h": 1 }
                    ],
                    "ix": 5
                  },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [25.22, 38.531], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.956, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "4",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": {
                    "a": 1,
                    "k": [
                      { "t": 0, "s": [0], "h": 1 },
                      { "t": 54, "s": [100], "h": 1 },
                      { "t": 57, "s": [0], "h": 1 }
                    ],
                    "ix": 5
                  },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [46.709, 38.531], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "5",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 5,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": { "a": 0, "k": 0, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [67.686, 38.531], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "6",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 6,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": {
                    "a": 1,
                    "k": [
                      { "t": 0, "s": [0], "h": 1 },
                      { "t": 38, "s": [100], "h": 1 },
                      { "t": 41, "s": [0], "h": 1 }
                    ],
                    "ix": 5
                  },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [25.22, 59.414], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.956, 93.085], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "7",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 7,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": {
                    "a": 1,
                    "k": [
                      { "t": 0, "s": [0], "h": 1 },
                      { "t": 46, "s": [100], "h": 1 },
                      { "t": 49, "s": [0], "h": 1 }
                    ],
                    "ix": 5
                  },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [46.709, 59.414], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.443, 93.085], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "8",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 8,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
                  "o": { "a": 0, "k": 0, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [67.686, 59.414], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [92.443, 93.085], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "9",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 9,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 240,
          "st": 0,
          "ct": 1,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "Phone BG",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0, "y": 1 },
                  "o": { "x": 0.167, "y": 0.167 },
                  "t": 9,
                  "s": [545.136, 240.391, 0],
                  "to": [-49.167, 0, 0],
                  "ti": [49.167, 0, 0]
                },
                { "t": 24, "s": [250.136, 240.391, 0] }
              ],
              "ix": 2,
              "l": 2
            },
            "a": { "a": 0, "k": [248.55, 243.15, 0], "ix": 1, "l": 2 },
            "s": { "a": 0, "k": [500, 500, 100], "ix": 6, "l": 2 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "rc",
                  "d": 1,
                  "s": { "a": 0, "k": [48.926, 36.963], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "r": { "a": 0, "k": 3, "ix": 4 },
                  "nm": "Rectangle Path 1",
                  "mn": "ADBE Vector Shape - Rect",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [248.483, 245.352], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "BG",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 6,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 240,
          "st": 0,
          "ct": 1,
          "bm": 0
        }
      ]
    }
  ],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Shine 2",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 32, "s": [0] },
            { "t": 52, "s": [135] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [236.24, 345.036, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [-466, -22, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 32,
              "s": [0, 0, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 41,
              "s": [81, 81, 100]
            },
            { "t": 52, "s": [0, 0, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-7.849, 0],
                    [-29.053, -29.053],
                    [0, -7.849],
                    [29.053, -29.053],
                    [7.849, 0],
                    [29.053, 29.053],
                    [0, 7.849],
                    [-29.053, 29.053]
                  ],
                  "o": [
                    [7.849, 0],
                    [29.053, 29.053],
                    [0, 7.849],
                    [-29.053, 29.053],
                    [-7.849, 0],
                    [-29.053, -29.053],
                    [0, -7.849],
                    [29.053, -29.053]
                  ],
                  "v": [
                    [0, -95.707],
                    [27.053, -27.053],
                    [95.707, 0],
                    [27.053, 27.053],
                    [0, 95.707],
                    [-27.053, 27.053],
                    [-95.707, 0],
                    [-27.053, -27.053]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.243133544922, 0.756805419922, 0.803863525391, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 12, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [-466, -22], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [35, 35], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Polystar 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 32,
      "op": 52,
      "st": 16,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Shine 1",
      "sr": 0.98000001907349,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 28, "s": [0] },
            { "t": 47.6000003814697, "s": [135] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [366.24, 159.036, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [-466, -22, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 28,
              "s": [0, 0, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 36.82,
              "s": [81, 81, 100]
            },
            { "t": 47.6000003814697, "s": [0, 0, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-7.84, 0],
                    [-29.071, -29.071],
                    [0, -7.84],
                    [29.071, -29.071],
                    [7.84, 0],
                    [29.071, 29.071],
                    [0, 7.84],
                    [-29.071, 29.071]
                  ],
                  "o": [
                    [7.84, 0],
                    [29.071, 29.071],
                    [0, 7.84],
                    [-29.071, 29.071],
                    [-7.84, 0],
                    [-29.071, -29.071],
                    [0, -7.84],
                    [29.071, -29.071]
                  ],
                  "v": [
                    [0, -95.603],
                    [27.07, -27.07],
                    [95.603, 0],
                    [27.07, 27.07],
                    [0, 95.603],
                    [-27.07, 27.07],
                    [-95.603, 0],
                    [-27.07, -27.07]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.243133544922, 0.756805419922, 0.803863525391, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 12, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [-466, -22], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [50, 50], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Polystar 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 28,
      "op": 47.6000003814697,
      "st": 12.3199996948242,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Shine 3",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 24, "s": [0] },
            { "t": 44, "s": [135] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [158.24, 225.036, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [-466, -22, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 24,
              "s": [0, 0, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 33,
              "s": [81, 81, 100]
            },
            { "t": 44, "s": [0, 0, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-7.849, 0],
                    [-29.053, -29.053],
                    [0, -7.849],
                    [29.053, -29.053],
                    [7.849, 0],
                    [29.053, 29.053],
                    [0, 7.849],
                    [-29.053, 29.053]
                  ],
                  "o": [
                    [7.849, 0],
                    [29.053, 29.053],
                    [0, 7.849],
                    [-29.053, 29.053],
                    [-7.849, 0],
                    [-29.053, -29.053],
                    [0, -7.849],
                    [29.053, -29.053]
                  ],
                  "v": [
                    [0, -95.707],
                    [27.053, -27.053],
                    [95.707, 0],
                    [27.053, 27.053],
                    [0, 95.707],
                    [-27.053, 27.053],
                    [-95.707, 0],
                    [-27.053, -27.053]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "sr",
              "sy": 1,
              "d": 1,
              "pt": { "a": 0, "k": 4, "ix": 3 },
              "p": { "a": 0, "k": [0, 0], "ix": 4 },
              "r": { "a": 0, "k": 0, "ix": 5 },
              "ir": { "a": 0, "k": 38.259, "ix": 6 },
              "is": { "a": 0, "k": 275, "ix": 8 },
              "or": { "a": 0, "k": 95.707, "ix": 7 },
              "os": { "a": 0, "k": 21, "ix": 9 },
              "ix": 2,
              "nm": "Polystar Path 1",
              "mn": "ADBE Vector Shape - Star",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.243133544922, 0.756805419922, 0.803863525391, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 12, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [-466, -22], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [45, 45], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Polystar 1",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 24,
      "op": 44,
      "st": 8,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Shine 4",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 20, "s": [0] },
            { "t": 40, "s": [135] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [316.24, 221.036, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [-466, -22, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 20,
              "s": [0, 0, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 29,
              "s": [81, 81, 100]
            },
            { "t": 40, "s": [0, 0, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-7.849, 0],
                    [-29.053, -29.053],
                    [0, -7.849],
                    [29.053, -29.053],
                    [7.849, 0],
                    [29.053, 29.053],
                    [0, 7.849],
                    [-29.053, 29.053]
                  ],
                  "o": [
                    [7.849, 0],
                    [29.053, 29.053],
                    [0, 7.849],
                    [-29.053, 29.053],
                    [-7.849, 0],
                    [-29.053, -29.053],
                    [0, -7.849],
                    [29.053, -29.053]
                  ],
                  "v": [
                    [0, -95.707],
                    [27.053, -27.053],
                    [95.707, 0],
                    [27.053, 27.053],
                    [0, 95.707],
                    [-27.053, 27.053],
                    [-95.707, 0],
                    [-27.053, -27.053]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.243133544922, 0.756805419922, 0.803863525391, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 12, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [-466, -22], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [35, 35], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Polystar 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 20,
      "op": 40,
      "st": 4,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 4,
      "nm": "Arrows",
      "parent": 6,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            { "i": { "x": [0.281], "y": [1] }, "o": { "x": [0.654], "y": [0] }, "t": 3, "s": [0] },
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.219], "y": [0] }, "t": 20, "s": [365] },
            { "i": { "x": [0.652], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 30, "s": [357] },
            { "t": 40, "s": [360] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [0.1, 0.05, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [267.4, 263.75, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [3.2, 0],
                    [1.2, 2.4],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-3.1, 0],
                    [-0.8, 3.8],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-0.8, 3.1],
                    [-2.8, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.5, 2.6],
                    [4, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [7.15, -3.35],
                    [7.05, -3.15],
                    [0.25, 2.15],
                    [-6.15, -1.85],
                    [-3.75, -1.85],
                    [-3.75, -3.25],
                    [-8.65, -3.25],
                    [-8.65, 1.45],
                    [-7.15, 1.45],
                    [-7.15, -0.75],
                    [0.25, 3.45],
                    [8.55, -3.15],
                    [8.65, -3.45],
                    [7.15, -3.45]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.043137256056, 0.145098045468, 0.152941182256, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [267.45, 268.55], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-3.2, 0],
                    [-1.2, -2.4],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [3.1, 0],
                    [0.9, -3.8],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0.8, -3.1],
                    [2.8, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.5, -2.6],
                    [-3.9, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-7.05, 3.25],
                    [-0.25, -2.05],
                    [6.15, 1.95],
                    [3.75, 1.95],
                    [3.75, 3.35],
                    [8.65, 3.35],
                    [8.65, -1.45],
                    [7.15, -1.45],
                    [7.15, 0.75],
                    [-0.25, -3.45],
                    [-8.55, 3.15],
                    [-8.65, 3.45],
                    [-7.15, 3.45]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.043137256056, 0.145098045468, 0.152941182256, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [267.35, 258.95], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 96,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 6,
      "ty": 4,
      "nm": "Circle",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [363.9, 335.9, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.304, 0.304, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.413, 0.413, 0.333], "y": [0, 0, 0] },
              "t": 0,
              "s": [500, 500, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.606, 0.606, 0.333], "y": [0, 0, 0] },
              "t": 9,
              "s": [550, 550, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.209, 0.209, 0.333], "y": [0, 0, 0] },
              "t": 18,
              "s": [480, 480, 100]
            },
            {
              "i": { "x": [0.419, 0.419, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 28,
              "s": [515, 515, 100]
            },
            { "t": 40, "s": [500, 500, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-8.174, 0],
                    [0, -8.174],
                    [8.174, 0],
                    [0, 8.174]
                  ],
                  "o": [
                    [8.174, 0],
                    [0, 8.174],
                    [-8.174, 0],
                    [0, -8.174]
                  ],
                  "v": [
                    [0, -14.8],
                    [14.8, 0],
                    [0, 14.8],
                    [-14.8, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 96,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 7,
      "ty": 0,
      "nm": "Old Phone 1",
      "refId": "comp_0",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.648], "y": [0] }, "t": 5, "s": [100] },
            { "t": 15, "s": [0] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [250, 250, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "w": 500,
      "h": 500,
      "ip": 0,
      "op": 16,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 8,
      "ty": 0,
      "nm": "New Phone",
      "refId": "comp_1",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 11, "s": [0] },
            { "t": 24, "s": [100] }
          ],
          "ix": 11
        },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [250, 250, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "w": 500,
      "h": 500,
      "ip": 11,
      "op": 96,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 9,
      "ty": 4,
      "nm": "BG",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [249.8, 249.9, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [500, 500, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-27.415, 0],
                    [0, -27.415],
                    [27.415, 0],
                    [0, 27.415]
                  ],
                  "o": [
                    [27.415, 0],
                    [0, 27.415],
                    [-27.415, 0],
                    [0, -27.415]
                  ],
                  "v": [
                    [0, -49.64],
                    [49.64, 0],
                    [0, 49.64],
                    [-49.64, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.839215695858, 0.937254905701, 0.952941179276, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 96,
      "st": 0,
      "ct": 1,
      "bm": 0
    }
  ],
  "markers": []
}
